document.addEventListener('submit', function (e) {
  const form = e.target;
  if (form.matches('form[action*="/cart"]')) {
    const submitter = e.submitter;
    if (submitter && submitter.name === 'checkout') {
      e.preventDefault();
      window.location.href = '/cart'; // replace with your real URL
    }
  }
}, true);